import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
// import dictionaries from './modules/dictionaries'
Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        user,
        // dictionaries
    }
})
export default store


// WEBPACK FOOTER //
// ./src/vuex/store.js